export const lottoLabels = [
  { title: 'Div 1 (Six Correct Numbers)' },
  { title: 'Div 2 (Five Correct Numbers + Bonus Ball)' },
  { title: 'Div 3 (Five Correct Numbers)' },
  { title: 'Div 4 (Four Correct Numbers + Bonus Ball)' },
  { title: 'Div 5 (Four Correct numbers)' },
  { title: 'Div 6 (Three Correct Numbers + Bonus Ball)' },
  { title: 'Div 7 (Three Correct Numbers)' },
  { title: 'Div 8 (Two Correct Numbers + Bonus Ball)' },
  { title: 'Div 9 (Match Powerball)' },
];

export const powerballLabels = [
  { title: 'Div 1 (Five Correct Numbers + Powerball)' },
  { title: 'Div 2 (Five Correct Numbers)' },
  { title: 'Div 3 (Four Correct Numbers + Powerball)' },
  { title: 'Div 4 (Four Correct Numbers)' },
  { title: 'Div 5 (Three Correct numbers + Powerball)' },
  { title: 'Div 6 (Three Correct Numbers)' },
  { title: 'Div 7 (Two Correct Numbers + Powerball)' },
  { title: 'Div 8 (One Correct Numbers + Powerball)' },
  { title: 'Div 9 (Match Powerball)' },
];

export const dailyLottoLabels = [
  { title: 'Div 1 (Five Correct Numbers)' },
  { title: 'Div 2 (Four Correct Numbers)' },
  { title: 'Div 3 (Three Correct Numbers)' },
  { title: 'Div 4 (Two Correct Numbers)' },
];
